var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophoneOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_6762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.2308 46.6312C78.2851 46.4885 75.7603 48.7495 75.5891 51.688C75.5891 51.7451 75.2111 57.672 71.5807 63.3565C66.9304 70.6458 59.0206 74.3403 48.0653 74.3403C44.5491 74.3403 41.3467 73.9552 38.4652 73.1992L30.0562 81.6082C33.4654 83.106 37.4524 84.2115 42.1027 84.7179V97.007H54.028V84.7179C84.6115 81.38 86.3019 52.5153 86.3161 52.2087C86.4517 49.2701 84.1764 46.7881 81.2237 46.6383L81.2308 46.6312Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8769 48.086V42.7795L44.3701 67.2863C45.1047 67.3719 45.8465 67.4218 46.6025 67.4218H49.5411C60.2182 67.4218 68.8769 58.7631 68.8769 48.086Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5058 6.05518L68.8773 20.6836V19.3285C68.8773 18.872 68.8559 18.4155 68.8274 17.9662C66.2835 20.1202 66.2764 20.1202 68.806 17.9662C68.107 7.92385 59.7408 -0.00732422 49.5272 -0.00732422H46.5887C36.5392 -0.00732422 28.28 7.65996 27.3456 17.4669C27.3456 17.4669 27.3599 17.4741 27.367 17.4812C27.3099 18.0875 27.2743 18.708 27.2743 19.3285V48.079C27.2743 52.1088 28.5082 55.8533 30.6265 58.9487L25.2416 64.3336C25.0133 64.0127 24.7851 63.6775 24.5711 63.3422C20.9764 57.7148 20.577 51.8449 20.5627 51.6808C20.413 48.7423 17.8739 46.4742 14.9567 46.6097C11.9897 46.7453 9.70017 49.2416 9.83568 52.1944C9.84281 52.3798 10.4633 62.8929 17.6099 71.9724L5.70605 83.8763V90.9373H12.7671L90.5882 13.1162V6.05518H83.5272H83.5058Z",
    fill: "black",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_6762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOff);
export default __webpack_public_path__ + "static/media/MicrophoneOff.751919619427f5aa953e0292656e5b5f.svg";
export { ForwardRef as ReactComponent };